module.exports = __webpack_public_path__ + "assets/gpt.0f908759.svg";